export type ThemeMode = "auto" | "light" | "dark";

export type ThemeAction =
  | { type: "CYCLE" }
  | { type: "IDLE" }
  | { type: "ACTIVE" }
  | { type: "TOGGLE_IDLE" };

export interface ThemeState {
  mode: ThemeMode;
  isIdle: boolean;
  /** Increments each time we transition from idle to active (in auto mode) */
  wakeCount: number;
}

const MODE_CYCLE: Record<ThemeMode, ThemeMode> = {
  auto: "light",
  light: "dark",
  dark: "auto",
};

export function themeReducer(state: ThemeState, action: ThemeAction): ThemeState {
  switch (action.type) {
    case "CYCLE":
      return { ...state, mode: MODE_CYCLE[state.mode] };
    case "IDLE":
      return { ...state, isIdle: true };
    case "ACTIVE":
      // Only increment wakeCount if we were actually idle (waking up)
      return {
        ...state,
        isIdle: false,
        wakeCount: state.isIdle ? state.wakeCount + 1 : state.wakeCount,
      };
    case "TOGGLE_IDLE":
      // If toggling from idle to active, increment wakeCount
      return {
        ...state,
        isIdle: !state.isIdle,
        wakeCount: state.isIdle ? state.wakeCount + 1 : state.wakeCount,
      };
  }
}

export function selectIsDark(state: ThemeState): boolean {
  switch (state.mode) {
    case "light":
      return false;
    case "dark":
      return true;
    case "auto":
      return state.isIdle;
  }
}

export function selectIsLocked(state: ThemeState): boolean {
  return state.mode !== "auto";
}

export const initialThemeState: ThemeState = {
  mode: "auto",
  isIdle: false,
  wakeCount: 0,
};
